module.exports = __webpack_public_path__ + "media/fundraising_sim/fun_img-sp01-87e8ddb0.png";